export default {
  props: {
    field: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Array, Boolean],
      default: null
    },
    filter: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      internalValue: '',
      focused: false,
      clearIconHovered: false
    }
  },
  computed: {
    isMultiple () {
      return !!this.filter.modifier && this.options.multipleValueFilterModifiers.includes(this.filter.modifier)
    },
    singleValueExternalStringified () {
      if (this.isMultiple || this.value === null) return ''
      return `${this.value}`
    },
    multipleValueExternalStringified () {
      if (!this.isMultiple || !Array.isArray(this.value)) return ''
      return this.value.reduce((acc, item) => {
        if (!`${item}`) return acc
        acc.push(item)
        return acc
      }, []).join(this.options.multipleValueFilterValuesDelimiter)
    },
    externalValueStringified () {
      return this.isMultiple ? this.multipleValueExternalStringified : this.singleValueExternalStringified
    },
    internalMultipleValueAsArray () {
      if (!this.isMultiple) return
      return this.internalValue
        .split(this.options.multipleValueFilterValuesDelimiter)
        .map(item => item.trim())
        .filter(item => !!item)
    },
    isChanged () {
      return this.externalValueStringified !== this.internalValue
    },
    showClearIcon () {
      return this.externalValueStringified && this.internalValue !== null && !this.isChanged
    }
  },
  watch: {
    externalValueStringified (val) {
      this.populate(val)
    },
    focused (val) {
      if (this.$refs.input && val && this.internalValue) this.$refs.input.$refs.input.select()
    }
  },
  methods: {
    populate (val) {
      this.internalValue = val
    },
    apply () {
      this.$nextTick(() => {
        if (this.isChanged) this.updateParent()
        if (this.focused && this.$refs.input) {
          !this.internalValue ? this.$refs.input.blur() : this.$refs.input.$refs.input.select()
        }
      })
    },
    updateParent () {
      this.$emit('input', [{
        field: this.field,
        modifier: this.filter.modifier || 'equals',
        value: this.isMultiple ? this.internalMultipleValueAsArray : this.internalValue
      }])
    },
    clear () {
      this.clearIconHovered = false
      this.internalValue = ''
      this.updateParent()
    }
  },
  created () {
    this.populate(this.externalValueStringified)
  }
}
